// API Configuration - reads from environment variables
// For Cloudflare Pages, set these in Settings > Environment Variables
// For Create React App, use REACT_APP_ prefix

// API Key for backend requests
export const API_KEY = process.env.REACT_APP_API_KEY || '';

// Allowed usernames (comma-separated in env variable)
// Example: REACT_APP_ALLOWED_USERNAMES=bekcom,masterzobs,newuser
const allowedUsernamesEnv = process.env.REACT_APP_ALLOWED_USERNAMES || '';
export const ALLOWED_USERNAMES: string[] = allowedUsernamesEnv
  ? allowedUsernamesEnv.split(',').map((u: string) => u.trim().toLowerCase())
  : [];

// API Base URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.tez.is';

// Environment endpoints
export const API_ENDPOINTS = {
  dev: 'https://api.tez.is',
  prod: 'https://api.tezda.tech',
};

// AI API endpoints (for recommendation/analytics APIs)
export const AI_API_ENDPOINTS = {
  dev: 'https://ai.tez.is',
  prod: 'https://ai.tezda.tech',
};

// WebSocket API endpoints (for chat/support APIs)
export const WS_API_ENDPOINTS = {
  dev: 'https://wss.tez.is',
  prod: 'https://wss.tezda.tech',
};

// Image Moderation API endpoints (analytics)
export const MODERATION_API_ENDPOINTS = {
  dev: 'https://moderation.tez.is',
  prod: 'https://moderation.tezda.tech',
};

// Report API endpoints (Redis-powered search for BulkReview)
export const REPORT_API_ENDPOINTS = {
  dev: process.env.REACT_APP_REPORT_API_BASE_URL_DEV || 'https://report-api.tez.is',
  prod: process.env.REACT_APP_REPORT_API_BASE_URL || 'https://report-api.tezda.tech',
};

// Analytics API endpoints (MongoDB analytics)
export const ANALYTICS_API_ENDPOINTS = {
  dev: 'https://report-api.tez.is',
  prod: 'https://report-api.tezda.tech',
};

// Get current AI API base URL based on environment toggle
export const getAiApiBaseUrl = (): string => {
  const savedEnv = localStorage.getItem('pingtop_environment');
  return savedEnv !== 'dev' ? AI_API_ENDPOINTS.prod : AI_API_ENDPOINTS.dev;
};

// Get current WebSocket API base URL based on environment toggle
export const getWsApiBaseUrl = (): string => {
  const savedEnv = localStorage.getItem('pingtop_environment');
  return savedEnv !== 'dev' ? WS_API_ENDPOINTS.prod : WS_API_ENDPOINTS.dev;
};

// Get current Moderation API base URL based on environment toggle
export const getModerationApiBaseUrl = (): string => {
  const savedEnv = localStorage.getItem('pingtop_environment');
  return savedEnv !== 'dev' ? MODERATION_API_ENDPOINTS.prod : MODERATION_API_ENDPOINTS.dev;
};

// Get current Report API base URL based on environment toggle
export const getReportApiBaseUrl = (): string => {
  const savedEnv = localStorage.getItem('pingtop_environment');
  return savedEnv !== 'dev' ? REPORT_API_ENDPOINTS.prod : REPORT_API_ENDPOINTS.dev;
};

// Get current Analytics API base URL based on environment toggle
export const getAnalyticsApiBaseUrl = (): string => {
  const savedEnv = localStorage.getItem('pingtop_environment');
  return savedEnv !== 'dev' ? ANALYTICS_API_ENDPOINTS.prod : ANALYTICS_API_ENDPOINTS.dev;
};

// Check if current user is the analytics admin (bek)
export const isAnalyticsUser = (): boolean => {
  const saved = localStorage.getItem('pingtop_saved_credentials');
  if (!saved) return false;
  try {
    const parsed = JSON.parse(saved);
    const username = (parsed.PhoneOrUserName || '').toLowerCase().trim();
    return username === 'bek';
  } catch {
    return false;
  }
};

// Get current API base URL based on environment toggle
export const getApiBaseUrl = (): string => {
  const savedEnv = localStorage.getItem('pingtop_environment');
  return savedEnv !== 'dev' ? API_ENDPOINTS.prod : API_ENDPOINTS.dev;
};

// Common headers for API requests
export const getApiHeaders = (authToken?: string) => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (authToken) {
    headers['Authorization'] = authToken;
  }

  return headers;
};
